<template>
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.57929 7.17109C3.37919 7.17109 3.18909 7.09104 3.04902 6.95097L0.217609 4.11956C-0.0725363 3.82941 -0.0725363 3.34917 0.217609 3.05903C0.507754 2.76888 0.987994 2.76888 1.27814 3.05903L3.57929 5.36018L8.72186 0.217609C9.012 -0.0725363 9.49225 -0.0725363 9.78239 0.217609C10.0725 0.507754 10.0725 0.987993 9.78239 1.27814L4.10955 6.95097C3.96948 7.09104 3.77939 7.17109 3.57929 7.17109Z"
            fill="white"
        />
    </svg>
</template>

<script>
export default {
    name: 'Check3Icon',
};
</script>
